import React from 'react'
import FligthsNew from '../../Components/FligthsNew/FligthsNew'

const FlightRoute = () => {
  const isIframe = window.location.pathname.startsWith('/iframe/fligths');
  return (
    <div>
        <FligthsNew isIframe={isIframe}></FligthsNew>
    </div>
  )
}

export default FlightRoute